import { Toast, ToastMessage } from "primereact/toast";
import { useEffect, useRef } from "react";

import { Message, MessageType } from "../components";

let globalToastRef: Toast | null = null;

export const showToast = (message: ToastMessage) => {
    globalToastRef?.show({
        ...message,
        closable: false,
        content: ({
            onClose,
        }: {
            message: ToastMessage;
            onClose?: () => void;
        }) => (
            <div className="relative w-full">
                <Message
                    type={(message.severity as MessageType) ?? MessageType.INFO}
                    className="pr-10"
                    entries={[
                        { title: message.summary, description: message.detail },
                    ]}
                />
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 w-7 h-7 flex items-center justify-center rounded-full text-default hover:bg-black/5"
                >
                    <i className="pi pi-times" />
                </button>
            </div>
        ),
    });
};

export const removeToast = (message: ToastMessage) => {
    globalToastRef?.remove(message);
};

export const clearToasts = () => {
    globalToastRef?.clear();
};

export const GlobalToast = () => {
    const ref = useRef<Toast>(null);

    useEffect(() => {
        globalToastRef = ref.current;
        return () => {
            globalToastRef = null;
        };
    }, []);

    return (
        <Toast
            ref={ref}
            pt={{
                message: { className: "!bg-transparent !border-0" },
                content: { className: "!p-0 !border-0" },
            }}
        />
    );
};
